export default __webpack_public_path__ + "b5d919f5a13f84866870042ae2b9686e.png";